import { Injectable } from '@angular/core';
import { ApiSendService } from '@global-services/ApiSend.service';
import { ApiUrlEnum } from '@global-models/ApiUrlEnum';
import { ExpenseVoucherLogRequestModel } from 'app/vbt-ticari/ExpenseVoucher/_models/expense-voucher-log-request.model';
import { ExpenseVoucherLogResponseModel } from 'app/vbt-ticari/ExpenseVoucher/_models/expense-voucher-log-response.model';
import { SearchRequestModel } from '../_models/SearchRequestModel';
import { InvoiceLogRequestModel } from '../../Invoice/_models/InvoiceLogRequestModel';
import { SearchResponseModel } from '../../common/_models/SearchResponseModel';
import { InvoiceLogResponseModel } from '../../Invoice/_models/InvoiceLogResponseModel';
import { DespatchAdviceLogRequestModel } from '../../DespatchAdvice/_models/DespatchAdviceLogRequestModel';
import { DespatchAdviceLogResponseModel } from '../../DespatchAdvice/_models/DespatchAdviceLogResponseModel';
import { UserAllLogRequestModel } from '../_models/UserAllLogRequestModel';
import { UserAllLogResponseModel } from '../_models/UserAllLogResponseModel';
import { SmmLogRequestModel } from '../../SMM/_models/SmmLogRequestModel';
import { SmmLogResponseModel } from '../../SMM/_models/SmmLogResponseModel';
import { CreditNoteLogRequestModel } from '../../EMM/_models/CreditNoteLogRequestModel';
import { WorkflowLogRequestModel } from '../../DynamicWorkflow/models/WorkflowLogRequestModel';
import { LogRequestModel } from '../../Ticket/_models/request/LogRequestModel';
import { LogResponseModel } from '../../Ticket/_models/response/LogResponseModel';
import { WorkflowLogResponseModel } from '../../DynamicWorkflow/models/WorkflowLogResponseModel';
import { BillLogRequestModel } from '../../Bill/_models/BillLogRequestModel';
import { BillLogResponseModel } from '../../Bill/_models/BillLogResponseModel';

@Injectable()
export class HistoryService {

  constructor(private _apiservice: ApiSendService) {
  }

  public async GetOutgoingInvoiceLog(invoice: SearchRequestModel<InvoiceLogRequestModel>) {

    if (invoice.Query.UUId !== undefined) {
      return await this._apiservice.PostAuthorization(ApiUrlEnum.Ticari, '/api/Log/GetOutgoingInvoiceLog', invoice);
    } else {
      return new SearchResponseModel<InvoiceLogResponseModel>();
    }
  }

  public async GetIncomingInvoiceLog(invoice: SearchRequestModel<InvoiceLogRequestModel>) {

    if (invoice.Query.UUId !== undefined) {
      return await this._apiservice.PostAuthorization(ApiUrlEnum.Ticari, '/api/Log/GetIncomingInvoiceLog', invoice);
    } else {
      return new SearchResponseModel<InvoiceLogResponseModel>();
    }
  }

  public async GetOutgoingDespatchAdviceLog(despatchAdvice: SearchRequestModel<DespatchAdviceLogRequestModel>) {

    if (despatchAdvice.Query.UUId !== undefined) {
      return await this._apiservice.PostAuthorization(ApiUrlEnum.Ticari, '/api/Log/GetOutgoingDespatchAdviceLog', despatchAdvice);
    } else {
      return new SearchResponseModel<DespatchAdviceLogResponseModel>();
    }
  }

  public async GetIncomingDespatchAdviceLog(despatchAdvice: SearchRequestModel<DespatchAdviceLogRequestModel>) {

    if (despatchAdvice.Query.UUId !== undefined) {
      return await this._apiservice.PostAuthorization(ApiUrlEnum.Ticari, '/api/Log/GetIncomingDespatchAdviceLog', despatchAdvice);
    } else {
      return new SearchResponseModel<DespatchAdviceLogResponseModel>();
    }
  }

  public async GetOutgoingSMMLog(smm: SearchRequestModel<SmmLogRequestModel>) {

    if (smm.Query.UUId !== undefined) {
      return await this._apiservice.PostAuthorization(ApiUrlEnum.Smm, '/api/Smm/GetOutgoingSmmLog', smm);
    } else {
      return new SearchResponseModel<SmmLogResponseModel>();
    }
  }

  public async GetOutgoingCreditNoteLog(smm: SearchRequestModel<CreditNoteLogRequestModel>) {

    if (smm.Query.UUId !== undefined) {
      return await this._apiservice.PostAuthorization(ApiUrlEnum.Emm, '/api/CreditNoteApi/GetOutgoingCreditNoteLog', smm);
    } else {
      return new SearchResponseModel<SmmLogResponseModel>();
    }
  }

  public async GetWorkflowLog(workflow: SearchRequestModel<WorkflowLogRequestModel>) {

    if (workflow.Query.WorkflowId > 0) {
      return await this._apiservice.PostAuthorization(ApiUrlEnum.Ticari, '/api/Log/GetWorkflowLog', workflow);
    } else {
      return new SearchResponseModel<WorkflowLogResponseModel>();
    }
  }


  public async GetHwTicketLog(ticket: SearchRequestModel<LogRequestModel>) {

    if (ticket.Query.UUId !== undefined) {
      return await this._apiservice.PostAuthorization(ApiUrlEnum.Ticket, '/api/Log/GetHwTicketLog', ticket);
    } else {
      return new SearchResponseModel<LogResponseModel>();
    }
  }

  public async GetPassengerListLog(ticket: SearchRequestModel<LogRequestModel>) {

    if (ticket.Query.UUId !== undefined) {
      return await this._apiservice.PostAuthorization(ApiUrlEnum.Ticket, '/api/Log/GetPassengerListLog', ticket);
    } else {
      return new SearchResponseModel<LogResponseModel>();
    }
  }

  public async GetEventTicketLog(ticket: SearchRequestModel<LogRequestModel>) {

    if (ticket.Query.UUId !== undefined) {
      return await this._apiservice.PostAuthorization(ApiUrlEnum.Ticket, '/api/Log/GetEventTicketLog', ticket);
    } else {
      return new SearchResponseModel<LogResponseModel>();
    }
  }

  public async GetOutgoingBillLog(bill: SearchRequestModel<BillLogRequestModel>) {

    if (bill.Query.UUId !== undefined) {
      return await this._apiservice.PostAuthorization(ApiUrlEnum.Bill, '/api/BillApi/GetOutgoingBillLog', bill);
    } else {
      return new SearchResponseModel<BillLogResponseModel>();
    }
  }

  public async GetAirwayTicketLog(ticket: SearchRequestModel<LogRequestModel>) {

    if (ticket.Query.UUId !== undefined) {
      return await this._apiservice.PostAuthorization(ApiUrlEnum.Ticket, '/api/Log/GetAirwayTicketLog', ticket);
    } else {
      return new SearchResponseModel<LogResponseModel>();
    }
  }

  public async GetUserAllLog(elasticsearch: SearchRequestModel<UserAllLogRequestModel>) {
    if (elasticsearch !== undefined) {
      return await this._apiservice.PostAuthorization(ApiUrlEnum.Ticari, '/api/Log/GetUserAllLog', elasticsearch);
    } else {
      return new SearchResponseModel<UserAllLogResponseModel>();
    }
  }

  public async GetOutgoingExpenseVoucherLog(model: SearchRequestModel<ExpenseVoucherLogRequestModel>) {

    if (model.Query.UUId !== undefined) {
      return await this._apiservice.PostAuthorization(ApiUrlEnum.ExpenseVoucher, '/api/ExpenseVoucherApi/GetOutgoingExpenseVoucherLog', model);
    } else {
      return new SearchResponseModel<ExpenseVoucherLogResponseModel>();
    }
  }

  public async LogOutgoingInvoiceHistoryInfo(invoiceId: string, message: string, logCode: string, invoiceNumber: string, pageName: string) {
    return await this._apiservice.PostAuthorization(ApiUrlEnum.Ticari, '/api/Log/LogOutgoingInvoiceHistoryInfo', {
      'invoiceId': invoiceId,
      'message': message,
      'logCode': logCode,
      'invoiceNumber': invoiceNumber,
      'pageName': pageName
    });
  }

  public async LogIncomingInvoiceHistoryInfo(invoiceId: string, message: string, logCode: string, invoiceNumber: string, pageName: string) {
    return await this._apiservice.GetAuthorization(ApiUrlEnum.Ticari, '/api/Log/LogIncomingInvoiceHistoryInfo?invoiceId=' + invoiceId +
      '&message=' + message +
      '&logCode=' + logCode +
      '&invoiceNumber=' + invoiceNumber +
      '&pageName=' + pageName);
  }

  // tslint:disable-next-line:max-line-length
  public async LogOutgoingDespatchAdviceHistoryInfo(despatchAdviceId: string, message: string, logCode: string, despatchAdviceNumber: string, pageName: string) {
    // tslint:disable-next-line:max-line-length
    return await this._apiservice.GetAuthorization(ApiUrlEnum.Ticari, '/api/Log/LogOutgoingDespatchAdviceHistoryInfo?despatchAdviceId=' + despatchAdviceId +
      '&message=' + message +
      '&logCode=' + logCode +
      '&despatchAdviceNumber=' + despatchAdviceNumber +
      '&pageName=' + pageName);
  }

  // tslint:disable-next-line:max-line-length
  public async LogIncomingDespatchAdviceHistoryInfo(despatchAdviceId: string, message: string, logCode: string, despatchAdviceNumber: string, pageName: string) {
    // tslint:disable-next-line:max-line-length
    return await this._apiservice.PostAuthorization(ApiUrlEnum.Ticari, '/api/Log/LogIncomingDespatchAdviceHistoryInfo?despatchAdviceId=' + despatchAdviceId +
      '&message=' + message +
      '&logCode=' + logCode +
      '&despatchAdviceNumber=' + despatchAdviceNumber +
      '&pageName=' + pageName, null);
  }

}
